import { render, staticRenderFns } from "./AmbitGeneralCrud.vue?vue&type=template&id=e95f9b2e&scoped=true&"
import script from "./AmbitGeneralCrud.vue?vue&type=script&lang=js&"
export * from "./AmbitGeneralCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95f9b2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
